import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import styles from "./dealerLogComponent.module.scss";
import SubTitleHeader from "../../../../components/subTitleHeader/SubTitleHeader";
import LogDetailsComponent from "../../../../components/logDetailsComponent/LogDetailsComponent";
import _ from "lodash";
import i18next from "i18next";
import TwoButtonFooterSection from "../../../../components/TwoButtonFooterSection/TwoButtonFooterSection";
import {
  getDealerLogs,
  getDealerLogsCSV,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import { downloadCsv } from "../../../../config/appConfig";
import PropTypes from "prop-types";

const DealerLogComponent = (props) => {
  const { onBack, start, setStart, id } = props;
  const [dealerLogDetails, setDealerLogDetails] = useState({});
  const { setApiErrorModalState } = useApiErrorModalContext();
  const fetchDealerLogs = useCallback(() => {
    getDealerLogs({ dealerId: id })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDealerLogDetails(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadDealerLog = () => {
    getDealerLogsCSV({ dealerId: id })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          downloadCsv(response.fileData, response.fileName);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };
  useEffect(() => {
    fetchDealerLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className={styles.logsWrapper} data-testid="DealerLogComponent">
      <Box className={styles.logsWrapper1}>
        <Box className={styles.logsWrapper2}>
          <Box className={styles.logsWrapper3}>
            <Box className="textboxDoubleWraper">
              <Box class={styles.textWrapper}>
                <Box class={styles.label}>{i18next.t("Dealer name")}</Box>
                <Box class={styles.labelValues}>
                  {_.get(dealerLogDetails, "dealerName", "-")}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={styles.logsWrapper4}>
            <SubTitleHeader title="Data deelnemer log" />

            <LogDetailsComponent
              logData={_.get(dealerLogDetails, "logs", [])}
              start={start}
              setStart={setStart}
              type="dealer"
            />
          </Box>
        </Box>

        <TwoButtonFooterSection
          btnlist={[
            {
              title: "Back",
              iconStyle: styles.Back,
              buttonType: "muibtn-secondary-with-border",
              attriType: "button",
              withIcon: true,
              showCountSection: false,
              count: "",
              handleClick: () => {
                onBack();
              },
              position: "left",
            },
            {
              title: "Download log",
              iconStyle: "",
              buttonType: "muibtn-primary",
              attriType: "button",
              withIcon: false,
              showCountSection: false,
              count: "",
              handleClick: () => downloadDealerLog(),
              position: "right",
              isDisabled: false

            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default DealerLogComponent;

DealerLogComponent.propTypes = {
  onBack:PropTypes.any, 
  start:PropTypes.any, 
  setStart:PropTypes.any, 
  id:PropTypes.any
}
